import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import http from './utils/http'
import utils from './utils/utils'
import "./assets/css/base.css";
import "./assets/css/style.css";
import "./assets/css/animation.css";
import "./utils/rem.js";
import store from './store'
import 'animate.css/animate.min.css';
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import i18n from './i18n'

Vue.config.productionTip = false;
Vue.http = Vue.prototype.$http = http
Vue.prototype.utils = utils

new Vue({
  render: h => h(App),
  router,
  store,
  i18n
}).$mount("#app");

Vue.use(Viewer)

Viewer.setDefaults({
  Options: { 'inline': true, 'button': true, 'navbar': true, 'title': true, 'toolbar': true, 'tooltip': true, 'movable': true, 'zoomable': true, 'rotatable': true, 'scalable': true, 'transition': true, 'fullscreen': true, 'keyboard': true, 'url': 'data-source' }
})
